<template>
  <nav class="nav nav-top hidden lg:block" :class="{ 'mobile': config.mobileMenuOpen }">
    <div class="container-fluid">
      <ul class="root">
        <top-menu-list-item @toggle-active="toggleActive(i)" :page="page" v-for="(page, i) in pages" :key="'page-'+i"></top-menu-list-item>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
const TopMenuListItem = resolve => require(['@/components/layout/TopMenuListItem'], resolve)

export default {
  components: {
    TopMenuListItem,
  },
  data() {
    return {
      pages: this.initial()
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    this.$EventBus.$on('reset-top-menu', this.reset)
  },
  destroyed() {
    this.$EventBus.$off('reset-top-menu')
  },
  methods: {
    reset() {
      this.pages = this.initial()
      this['config/setMobileMenu'](false)
    },
    toggleActive(index) {
      this.$set(this.pages[index], 'active', !this.pages[index].active)
    },
    initial() {
      return [
        {
          title: '',
          icon: 'fas fa-home',
          path: '/',
          route: 'dashboard'
        },
        {
          title: 'Jobs',
          icon: 'fas fa-bolt',
          children: [
            {title: 'List', path: '/job/list', route: 'job.list'},
            {title: 'Create', path: '/job/create', route: 'job.create'},
          ]
        },
        {
          title: 'Customers',
          icon: 'fas fa-users',
          children: [
            {title: 'List', path: '/customer/list', route: 'customer.list'},
            {title: 'Create', path: '/customer/create', route: 'customer.create'},
          ]
        },
        {
          title: 'Vehicles',
          icon: 'fas fa-car-side',
          children: [
            {title: 'List', path: '/vehicle/list', route: 'vehicle.list'},
            {title: 'Create', path: '/vehicle/create', route: 'vehicle.create'},
          ]
        },
        {
          title: 'Suppliers',
          icon: 'fas fa-parachute-box',
          children: [
            {title: 'List Suppliers', path: '/supplier/list', route: 'supplier.list'},
            {title: 'List Supplier Accounts', path: '/supplier/account/list', route: 'supplier.list'},
            {title: 'Create Supplier', path: '/supplier/create/accounts', route: 'supplier.create.accounts'},
          ]
        },
        {
          title: 'Products',
          icon: 'fas fa-cube',
          children: [
            {title: 'List', path: '/product/list', route: 'product.list'},
            {title: 'Create', path: '/product/create', route: 'product.create'},
          ]
        },
        {
          title: 'Accounting',
          icon: 'far fa-file-alt',
          children: [
            {
              title: 'Invoices',
              icon: 'fe-file-text',
              children: [
                {title: 'List', path: '/invoice/list', route: 'invoice.list'},
                {title: 'Create', path: '/invoice/create', route: 'invoice.create'},
              ]
            },
            {
              title: 'Credit notes',
              icon: 'fe-shuffle',
              children: [
                {title: 'List', path: '/credit-note/list', route: 'credit-note.list'},
              ]
            },
            {
              title: 'Payments',
              icon: 'fe-dollar-sign',
              children: [
                {title: 'List', path: '/payment/list', route: 'payment.list'},
              ]
            },
            {
              title: 'Receipts',
              icon: 'fe-dollar-sign',
              children: [
                {title: 'List', path: '/receipt/list', route: 'receipt.list'},
              ]
            },
          ]
        },
        {
          title: 'Reminders',
          icon: 'far fa-envelope',
          children: [
            {title: 'List', path: '/reminder/list', route: 'reminder.list'},
            {title: 'Create', path: '/reminder/create', route: 'reminder.create'},
            {
              title: 'Reminder Lists',
              icon: 'fe-file-text',
              children: [
                {title: 'List', path: '/reminder-list/list', route: 'reminder-list.list'},
                {title: 'Create', path: '/reminder-list/create', route: 'reminder-list.create'},
              ]
            },
          ]
        },
        {
          title: 'Reports',
          icon: 'fas fa-chart-line',
          last: true,
          children: [
            {title: 'Payments', path: '/report/payments', route: 'report.payments'},
            {title: 'Products', path: '/report/products', route: 'report.products'},
            {title: 'Ageing of accounts', path: '/report/ageing-of-accounts', route: 'report.ageing-of-accounts'},
            {title: 'Accounting', path: '/report/accounting-links', route: 'report.accounting-links'},
          ]
        },
      ]
    },
    ...mapActions([
      'config/setMobileMenu',
    ])
  }
}
</script>
